/* eslint-disable prefer-destructuring, class-methods-use-this, no-undef, camelcase, prefer-template */

import Pagination from "./pagination";

class Filters {
  constructor() {
    this.filtersButtons = document.getElementsByClassName("js-filters");

    if (this.filtersButtons[0]) {
      this.init();
    }
  }

  init() {
    const filterPosts = this.filterPosts;
    const removeElementsByClass = this.removeElementsByClass;
    const filterButtons = this.filtersButtons;
    const thisClass = this;

    // Filters click event
    Array.prototype.forEach.call(this.filtersButtons, (filterButton) => {
      // eslint-disable-next-line
      filterButton.addEventListener("click", function (event) {
        const postType = this.dataset.postType;
        const taxonomy = this.dataset.taxonomy;
        const columns = this.dataset.columns;
        const term = this.dataset.term;
        const titleLength = this.dataset.titleLength;
        const pagination = this.dataset.pagination;
        const viewAll = this.dataset.viewAll;
        const maxPosts = this.dataset.maxPosts;

        event.preventDefault();
        thisClass.toggleActiveClass(filterButtons, this);
        filterPosts(
          postType,
          taxonomy,
          term,
          titleLength,
          pagination,
          viewAll,
          maxPosts,
          columns,
          this,
          removeElementsByClass
        );
      });
    });

    // Check if the url contains a filter. If it's true, then apply the filter.
    try {
      const urlString = window.location.href.toLowerCase();
      const url = new URL(urlString);
      const term = url.searchParams.get("term");

      if (term) {
        Array.prototype.forEach.call(this.filtersButtons, (filterButton) => {
          if (filterButton.dataset.term === term) {
            filterButton.click();
          }
        });
      }
    } catch (err) {
      console.error("Issues with Parsing URL Parameter's - " + err); // eslint-disable-line
    }
  }

  filterPosts(
    postType,
    taxonomy,
    term,
    titleLength,
    pagination,
    viewAll,
    maxPosts,
    columns,
    element,
    removeElementsByClass
  ) {
    const request = window.ajaxReq();
    let url = encodeURI(scriptsAjaxVariables.ajax_url); // eslint-disable-line
    const data =
      "action=filter_posts" +
      "&post-type=" +
      postType +
      "&taxonomy=" +
      taxonomy +
      "&term=" +
      term +
      "&title-length=" +
      titleLength +
      "&pagination=" +
      pagination +
      "&view-all=" +
      viewAll +
      "&max-posts=" +
      maxPosts +
      "&columns=" +
      columns +
      "&nonce=" +
      scriptsAjaxVariables.nonce;

    request.open("POST", url, true); // set true for async, false for sync request
    request.setRequestHeader(
      "Content-type",
      "application/x-www-form-urlencoded"
    );
    request.send(data); // or null, if no parameters are passed

    // On success append data
    request.onreadystatechange = () => {
      if (request.readyState === 4 && request.status === 200) {
        try {
          const grid = element.closest(".projects-grid");
          const gridCards = grid.getElementsByClassName("js-grid-cards")[0];

          // Remove current data
          removeElementsByClass(gridCards, "projects-grid-card");

          // Remove current pagination
          const currentLoadMoreButtons = document.getElementsByClassName(
            "js-pagination-load-more"
          )[0];

          if (currentLoadMoreButtons) {
            const currentPaginationContainer =
              currentLoadMoreButtons.parentElement;

            if (currentPaginationContainer) {
              currentPaginationContainer.remove();
            }
          }

          // Append data
          gridCards.innerHTML = request.responseText;

          // Reposition new pagination
          const loadMoreButtons = gridCards.getElementsByClassName(
            "js-pagination-load-more"
          )[0];

          if (loadMoreButtons) {
            const paginationContainer = loadMoreButtons.parentElement;
            gridCards.parentElement.appendChild(paginationContainer);
          }

          // Reload load more button
          window.pagination = new Pagination();

          // Cards animation
          import(
            /* webpackChunkName: "library-scrollmagic" */ "scrollmagic"
          ).then(({ default: ScrollMagic }) => {
            window.setAnimationScenes(new ScrollMagic.Controller());
          });

          // Trigger lazy loading
          window.lazyLoading.init();
        } catch (error) {
          console.log(error); // eslint-disable-line no-console
        }
      }
    };
  }

  removeElementsByClass(element, className) {
    const elements = element.getElementsByClassName(className);

    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }

  toggleActiveClass(filters, newFilter) {
    // Remove current active filter
    for (let i = 0; i < filters.length; i += 1) {
      filters[i].classList.remove("active");
    }

    // Set new active filter
    newFilter.classList.add("active");
  }
}

export default Filters;
